import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetTrialBalanceLineItemReportProps {
  glMasterId: string;
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTrialBalanceLineItemReport = async (glMasterId: string, filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/gl/${glMasterId}/line-items?${new URLSearchParams(filter).toString()}`);

const useGetTrialBalanceLineItemReport = ({
  glMasterId,
  filter,
  queryParams,
}: UseGetTrialBalanceLineItemReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["trial-balance-line-item-report", glMasterId],
    queryFn: () => getTrialBalanceLineItemReport(glMasterId, filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTrialBalanceLineItemReport;
